// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ConfidenceLevelSchema } from '../inputTypeSchemas/ConfidenceLevelSchema'

/////////////////////////////////////////
// TECHNOLOGY SCHEMA
/////////////////////////////////////////

export const TechnologySchema = z.object({
  confidence: ConfidenceLevelSchema,
  name: z.string(),
  version: z.string().nullable(),
  category: z.string(),
  purpose: z.string(),
  repositoryName: z.string(),
  relatedNodeIds: z.string().array(),
})

export type Technology = z.infer<typeof TechnologySchema>

export default TechnologySchema;
